import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, NgModule } from '@angular/core';
import { SeFeAnalytics } from 'se-analytics-js';

const seAnalyticsConfig = new InjectionToken('seAnalyticsConfig');
const consumingApp = seAnalyticsConfig; // deprecated token name
class SeAnalyticsService extends SeFeAnalytics {
    constructor(config) {
        super(config);
        this.config = config;
        // noop
    }
}
SeAnalyticsService.ɵfac = function SeAnalyticsService_Factory(t) { return new (t || SeAnalyticsService)(i0.ɵɵinject(seAnalyticsConfig)); };
SeAnalyticsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SeAnalyticsService, factory: SeAnalyticsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SeAnalyticsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [seAnalyticsConfig]
            }] }]; }, null); })();

class SeAnalyticsModule {
    static forRoot(config) {
        return {
            ngModule: SeAnalyticsModule,
            providers: [
                {
                    provide: consumingApp,
                    useValue: config
                }
            ]
        };
    }
}
SeAnalyticsModule.ɵfac = function SeAnalyticsModule_Factory(t) { return new (t || SeAnalyticsModule)(); };
SeAnalyticsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SeAnalyticsModule });
SeAnalyticsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [SeAnalyticsService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SeAnalyticsModule, [{
        type: NgModule,
        args: [{
                providers: [SeAnalyticsService]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { SeAnalyticsModule, SeAnalyticsService, consumingApp, seAnalyticsConfig };
